export default "__VITE_ASSET__DaUzb$Cw__"